import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { partnerApi } from 'utils/api'
import { buildUrl } from 'utils/helpers'

export const fetchPartnerPrograms = createAsyncThunk(
  'partnerPrograms/fetchList',
  async ({ companyUuid, state }, { rejectWithValue, dispatch }) => {
    try {
      const payload = await partnerApi.request(
        buildUrl('/partner_programs', { company_uuid: companyUuid, state }),
        { dispatch },
      )
      return payload
    } catch {
      return rejectWithValue()
    }
  },
)

export const activatePartnerProgram = createAsyncThunk(
  'partnerPrograms/activate',
  async ({ companyUuid, programId }, { rejectWithValue, dispatch }) => {
    try {
      const payload = await partnerApi.request(
        buildUrl(`/partner_programs/${programId}/activate`, {
          company_uuid: companyUuid,
        }),
        { method: 'POST', dispatch },
      )
      return payload
    } catch {
      return rejectWithValue()
    }
  },
)

export const deactivatePartnerProgram = createAsyncThunk(
  'partnerPrograms/deactivate',
  async ({ companyUuid, programId }, { rejectWithValue, dispatch }) => {
    try {
      const payload = await partnerApi.request(
        buildUrl(`/partner_programs/${programId}/deactivate`, {
          company_uuid: companyUuid,
        }),
        { method: 'POST', dispatch },
      )
      return payload
    } catch {
      return rejectWithValue()
    }
  },
)

export const partnerProgramsSlice = createSlice({
  name: 'partnerPrograms',
  initialState: {
    list: null,
    filter: 'all',
    pending: false,
    togglingId: null,
  },
  reducers: {
    setPartnerProgramsFilter: (state, { payload }) => {
      state.filter = payload
    },
  },
  extraReducers: {
    [fetchPartnerPrograms.pending]: (state) => {
      state.pending = true
    },
    [fetchPartnerPrograms.fulfilled]: (state, { payload }) => {
      state.list = payload
      state.pending = false
    },
    [fetchPartnerPrograms.rejected]: (state) => {
      state.list = []
      state.pending = false
    },
    [activatePartnerProgram.pending]: (state, { meta }) => {
      state.togglingId = meta.arg.programId
    },
    [activatePartnerProgram.fulfilled]: (state, { payload }) => {
      state.list = state.list.map((p) => (p.id === payload.id ? payload : p))
      state.togglingId = null
    },
    [activatePartnerProgram.rejected]: (state) => {
      state.togglingId = null
    },
    [deactivatePartnerProgram.pending]: (state, { meta }) => {
      state.togglingId = meta.arg.programId
    },
    [deactivatePartnerProgram.fulfilled]: (state, { payload }) => {
      state.list = state.list.map((p) => (p.id === payload.id ? payload : p))
      state.togglingId = null
    },
    [deactivatePartnerProgram.rejected]: (state) => {
      state.togglingId = null
    },
  },
})

export const { setPartnerProgramsFilter } = partnerProgramsSlice.actions

export default partnerProgramsSlice.reducer
